"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialIcon = exports.SocialIconsContainer = exports.Author = exports.Link = exports.Column = exports.Avatar = exports.Subtitle = exports.StyledH2 = exports.TextContainer = exports.Container = exports.StyledSlider = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
var _typography = require("@berlitz/globals/lib/components/typography");
var _link = require("@berlitz/link");
require("slick-carousel/slick/slick.css");
require("slick-carousel/slick/slick-theme.css");
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var StyledSlider = (0, _styledComponents.default)(_reactSlick.default).withConfig({
  displayName: "Testimonialsstyle__StyledSlider",
  componentId: "sc-16fbg39-0"
})([".slick-list{margin:0 75px;}.slick-slide{div{outline:none;}}.slick-dots{button{&:focus{outline-color:-webkit-focus-ring-color;outline-style:auto;}&::before{font-size:", ";color:", ";opacity:0.3;transition:", ";@media (min-width:", "){font-size:", ";}}}li.slick-active{button::before{color:", ";opacity:1;}}}.slick-arrow{z-index:1;top:unset;bottom:50%;::before{color:", ";font-size:", ";}&.slick-prev{left:0px;}&.slick-next{right:20px;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.md;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.testimonials.dotColorActive;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.animation.transitionMedium;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.md;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.sm;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.testimonials.dotColorActive;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.brandPrimary;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.xxl;
});
exports.StyledSlider = StyledSlider;
var Container = _styledComponents.default.div.withConfig({
  displayName: "Testimonialsstyle__Container",
  componentId: "sc-16fbg39-1"
})(["display:flex;flex-direction:column;margin:0 auto;max-width:", ";@media (min-width:", "){flex-direction:row;}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.testimonials.maxWidth;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.md;
});
exports.Container = Container;
var TextContainer = _styledComponents.default.div.withConfig({
  displayName: "Testimonialsstyle__TextContainer",
  componentId: "sc-16fbg39-2"
})(["flex:1;margin-bottom:", ";padding:0;", " @media (min-width:", "){padding:", ";}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.lg;
}, (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    text-align: left;\n  "]))), function (_ref12) {
  var theme = _ref12.theme;
  return theme.breakpoints.md;
}, function (_ref13) {
  var theme = _ref13.theme;
  return "0 0 0 ".concat(theme.space.xxxl);
});
exports.TextContainer = TextContainer;
var StyledH2 = (0, _styledComponents.default)(_typography.H2).withConfig({
  displayName: "Testimonialsstyle__StyledH2",
  componentId: "sc-16fbg39-3"
})(["text-align:center;margin-bottom:", ";"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.space.sm;
});
exports.StyledH2 = StyledH2;
var Subtitle = (0, _styledComponents.default)(_typography.P).withConfig({
  displayName: "Testimonialsstyle__Subtitle",
  componentId: "sc-16fbg39-4"
})(["text-align:center;margin-bottom:", ";"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.xl;
});
exports.Subtitle = Subtitle;
var Avatar = _styledComponents.default.div.withConfig({
  displayName: "Testimonialsstyle__Avatar",
  componentId: "sc-16fbg39-5"
})(["background-image:", ";width:", ";height:", ";background-size:cover;background-position:center;border-radius:50%;align-self:center;margin:", ";@media (min-width:", "){width:", ";height:", ";margin:", ";}"], function (props) {
  return "url('".concat(props.image, "')");
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.testimonials.imageSizeMobile;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.testimonials.imageSizeMobile;
}, function (_ref18) {
  var theme = _ref18.theme;
  return "".concat(theme.space.xxs, " 0 ").concat(theme.space.md);
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.breakpoints.md;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.testimonials.imageSizeDesktop;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.testimonials.imageSizeDesktop;
}, function (_ref22) {
  var theme = _ref22.theme;
  return "".concat(theme.space.xxs, " 0 ").concat(theme.space.lg, " ").concat(theme.space.sm);
});
exports.Avatar = Avatar;
var Column = _styledComponents.default.div.withConfig({
  displayName: "Testimonialsstyle__Column",
  componentId: "sc-16fbg39-6"
})(["display:flex;flex-direction:column;align-items:center;"]);
exports.Column = Column;
var Link = _styledComponents.default.a.withConfig({
  displayName: "Testimonialsstyle__Link",
  componentId: "sc-16fbg39-7"
})(["", ""], _link.linkStyle);
exports.Link = Link;
var Author = _styledComponents.default.cite.withConfig({
  displayName: "Testimonialsstyle__Author",
  componentId: "sc-16fbg39-8"
})(["color:", ";font-size:", ";font-weight:", ";line-height:", ";margin-bottom:", ";display:block;"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.text01;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.fontSize.xxs;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.fontWeight.bold;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.lineHeight.md;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.space.md;
});
exports.Author = Author;
var SocialIconsContainer = _styledComponents.default.div.withConfig({
  displayName: "Testimonialsstyle__SocialIconsContainer",
  componentId: "sc-16fbg39-9"
})(["display:flex;justify-content:flex-start;align-items:center;margin-bottom:", ";"], function (_ref28) {
  var theme = _ref28.theme;
  return theme.space.lg;
});
exports.SocialIconsContainer = SocialIconsContainer;
var SocialIcon = _styledComponents.default.a.withConfig({
  displayName: "Testimonialsstyle__SocialIcon",
  componentId: "sc-16fbg39-10"
})(["height:", ";width:", ";transition:", ";margin-right:", ";@media (min-width:", "){&:last-child{margin-right:0;}}"], function (_ref29) {
  var theme = _ref29.theme;
  return theme.fontSize.sm;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.fontSize.sm;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.animation.transitionMedium;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.space.xs;
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.breakpoints.lg;
});
exports.SocialIcon = SocialIcon;